import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";
import { useSettingsStore } from "@/store/settings/settingsStore";

const settingSitemapToggle = () => {
    const debugMode = useSettingsStore().settings.useSitemap ? "enabled" : "disabled";
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:sitemap:${debugMode}`, 
        category: settings.categoryName 
    });
};

export default settingSitemapToggle;